<template>
    <div class="modal fade" :id="'modal-delete-' + idKey" tabindex="-1" role="dialog" :aria-labelledby="'modal-delete-' + idKey" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header text-center danger">
                    <h4>Confirmation</h4>
                </div>
                <div class="modal-body">
                    <p>This action will permanently remove the photo from our database!</p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger btn-large pull-left" data-toggle="modal" :data-target="'#modal-delete-' + idKey">Cancel</button>
                    <button class="btn btn-primary btn-large" v-on:click="$emit('deletePhoto')" data-toggle="modal" :data-target="'#modal-delete-' + idKey">Delete</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'TalentDeletePhotoModal',

  props: ['idKey']
}

</script>
